module.exports = __webpack_public_path__ + "static/media/Hero-Lounge.2e222644.jpg";